import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainComponent } from './main.component';
import { RouterModule } from '@angular/router';
import { ContentModule } from './content/content.module';
import { UserModule } from './user/user.module';
import { RegistrationComponent } from './registration/registration.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastsContainerComponent } from '../core/components/toast/toasts-container.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { CoreModule } from '../core/core.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LogoComponent } from '../core/components/logo/logo.component';
import { LanguageSwitcherComponent } from '../core/components/language-switcher/language-switcher.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    CoreModule,
    ContentModule,
    UserModule,
    ToastsContainerComponent,
    LogoComponent
  ],
  declarations: [
    MainComponent,
    RegistrationComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    NotFoundComponent,
    LanguageSwitcherComponent
  ],
  exports: [
    MainComponent,
    RegistrationComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
  ]
})
export class MainModule {}
